import {ThunkAction} from '../../store/appThunk';
import {findMessageQueue} from './specializedTaskQueues';

export function pushMessageDeletedTask(messageUid: string): ThunkAction {
  return async (dispatch, getState) => {
    // Wait for our turn to act and report as deleted.
    const queue = findMessageQueue(dispatch, getState, messageUid);
    await queue.waitForTurnAsync();
    queue.reportDeleted();
  };
}
